import { connectFeatureFlag } from './FeatureFlagConnectors';

const FeatureFlagged = ({ enabledFeatureFlags, only, except, children }) => {
  if (only && !only.some(flag => enabledFeatureFlags.indexOf(flag) > -1)) {
    return null;
  }

  if (except && except.some(flag => enabledFeatureFlags.indexOf(flag) > -1)) {
    return null;
  }

  return children;
};

export default connectFeatureFlag(FeatureFlagged);
